export const TextEffectsRetroViewerType = 'wixui.TextEffectsRetro' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsRetro-container',
    text: 'TextEffectsRetro-text',
  },
} as const;
